import { Outlet } from 'react-router-dom'

import LoadingWithBackdrop from '~/components/loadingWithBackdrop'
import useGetAuthSessionQuery from '~/features/auth/hooks/useGetAuthSessionQuery'
import PartnerThemeWrapper from '~/features/partners/components/partnerThemeWrapper'
import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import useStoreTrackingParams from '~/hooks/useStoreTrackingParams'

function WhiteLabelLayout() {
  const { isLoading: isLoadingAuthSession } = useGetAuthSessionQuery()
  const { partner, isLoading: isLoadingPartner } = usePartnerCentralized() // todo: do we need isLoadingPartner?

  useStoreTrackingParams()

  if (isLoadingAuthSession || isLoadingPartner || !partner.brandUIColors) {
    return <LoadingWithBackdrop show />
  }

  return (
    <PartnerThemeWrapper>
      <Outlet />
    </PartnerThemeWrapper>
  )
}

export default WhiteLabelLayout
